// extracted by mini-css-extract-plugin
export default {"nav":"Navigator_nav__JxgZY","upline":"Navigator_upline__2VEVW","downline":"Navigator_downline__G6Noj","upOn":"Navigator_upOn__DjvQy","downOn":"Navigator_downOn__vDuj+"};